import useCurrentRole from 'containers/User/useCurrentRole.js';
import { GROUP_MEMBER_TYPES } from './constants.js';

function useGroupTypes(groupType) {
  const { school } = useCurrentRole();
  const types = GROUP_MEMBER_TYPES[school.type];
  if (!groupType) {
    return types;
  }
  return types.find((t) => t.key === groupType);
}

export default useGroupTypes;
